import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi, { HttpBackendOptions } from 'i18next-http-backend';

import deTranslations from './locales/de.json'
import enTranslations from './locales/en.json'

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    debug: false,
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'es', 'fr', 'nl', 'pl', 'no', 'pt', 'it', 'tr', 'bg', 'hr', 'ru', 'uk', 'lt', 'el', 'sr', 'sq', 'hu', 'th', 'sk', 'ro', 'cs', 'fa', 'mt'],
    load: 'languageOnly',
    partialBundledLanguages: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator'],
    },
    resources: {
      en: {
        translation: enTranslations,
      },
      de: {
        translation: deTranslations,
      },
    },
  });

export default i18n;
